import {useQuery, gql} from '@apollo/client'
export default function useQueryPermission() {
  const queryPermission = gql`
    query {
      healthEquityConditionList {
        dataAggregationPermissions
        trendAnalysisPermissions
        userfeedbackFlagPermissions
        exportFlagPermissions
        chatbotFlagPermissions
        chatbotExportPermissions
        chatbotCopyPermissions
        usecasePermissions
        personaFlagPermissions
        benefitsEligibilityPermissions
        workforceRecruitmentPermissions
        pointOfInterestList
        groupId
        groupName
        clientId
        clientName
        userRole
      }
    }
  `

  const {
    data: permission,
    loading: loadingPermission,
    refetch: refetchPermission,
    error: errorLoadingPermission
  } = useQuery(queryPermission, {
    notifyOnNetworkStatusChange: true
  })
  return {
    permission,
    loadingPermission,
    refetchPermission,
    errorLoadingPermission
  }
}
